import { useEffect, useState } from 'react';
import useSteps from '../context/steps.context';
import useConfig from '../context/config.context';
import useAccountSummary from './useAccountSummary';
const replaceYourCard = 'replace your card';
const lostOrStolen = 'lost or stolen';
const accountServices = 'account services';
const damagedCard = 'damaged card';
const neverReceived = 'never received card';
const misplacedCard = 'misplaced card';
const getEventOptions = ({ hasTransactions, error, defaultAnalytics, replacementReason }) => ({
    CloseConfirmation: Object.assign(Object.assign({}, defaultAnalytics), { pageName: 'cancel confirmation' }),
    Confirmation: Object.assign(Object.assign({}, defaultAnalytics), { pageName: 'success' }),
    UnableSubmit: Object.assign(Object.assign({}, defaultAnalytics), { errorMessage: error ? 'Please make a selection' : '', pageSubFunction: damagedCard, pageName: 'submit failed' }),
    ReasonSelection: Object.assign(Object.assign({}, defaultAnalytics), { errorMessage: error ? 'Please make a selection' : '', pageName: error ? 'situation selection:error' : 'situation selection' }),
    RecognizeTransactions: Object.assign(Object.assign({}, defaultAnalytics), { message: hasTransactions ? '' : 'no transactions found', pageSubFunction: neverReceived, pageName: 'recognize transaction' }),
    CantProcess: Object.assign(Object.assign({}, defaultAnalytics), { message: "We can't process your request online", pageSubFunction: replacementReason
            ? replacementReason.replace('-', ' ')
            : '', pageName: 'not eligible' }),
    SelectAccount: Object.assign(Object.assign({}, defaultAnalytics), { errorMessage: error ? 'Please select one or more cardholders' : '', pageSubFunction: damagedCard, pageName: error ? 'cardholder selection:error' : 'cardholder selection' }),
    ReviewDamagedCard: Object.assign(Object.assign({}, defaultAnalytics), { message: 'Once you submit this request it can’t be reversed. You can continue using your account until the new card arrives.', pageSubFunction: damagedCard, pageName: 'review' }),
    ReviewMisplacedCard: Object.assign(Object.assign({}, defaultAnalytics), { pageFunction: lostOrStolen, message: 'Once you submit this request it can’t be reversed. You will receive a replacement card with the same account number. If you find your misplaced card, you may continue using it until you activate your new card.', pageSubFunction: misplacedCard, pageName: 'review' }),
    ReviewNeverReceived: Object.assign(Object.assign({}, defaultAnalytics), { message: 'Once you submit this request it can’t be reversed. Cards for the users below will no longer work and will be reissued with a new account number. Allow up to 7 days for your account to reflect these new details.', pageSubFunction: neverReceived, pageName: 'review' }),
    CantVerify: Object.assign(Object.assign({}, defaultAnalytics), { message: "we're having trouble verifying your identity", pageName: 'authentication failed' }),
    ExitConfirmation: Object.assign(Object.assign({}, defaultAnalytics), { message: 'your information will not be saved', pageName: 'profile exit confirmation' })
});
const useAnalytics = (isSuccess, { isSemu, hasTransactions, error }) => {
    const { stepsState: { activeStep } } = useSteps();
    const { triggerAnalyticsEvent } = useConfig();
    const [hasErrorOccured, setHasErrorOccured] = useState(false);
    const [fired, setFired] = useState(false);
    const { currentReason } = useAccountSummary();
    const getFlowValue = (reason) => {
        if (reason) {
            return reason.value === 'damaged-card' ? damagedCard : neverReceived;
        }
        return '';
    };
    const getPageSubFunction = () => {
        const damagedCardPage = [
            'UnableSubmit',
            'SelectAccount',
            'ReviewDamagedCard'
        ];
        const subFunctionBasedOnFlow = [
            'ReasonSelection',
            'ExitConfirmation',
            'Confirmation',
            'CloseConfirmation',
            'CantVerify'
        ];
        if (subFunctionBasedOnFlow.includes(activeStep)) {
            return getFlowValue(currentReason);
        }
        return damagedCardPage.includes(activeStep) ? damagedCard : neverReceived;
    };
    const getDefaultAnalytics = () => {
        return {
            messageType: isSemu ? 'semu' : 'nonsemu',
            pageFunction: replaceYourCard,
            pageSubFunction: getPageSubFunction(),
            pageKind: accountServices
        };
    };
    const defaultAnalytics = getDefaultAnalytics();
    useEffect(() => {
        const eventOptions = getEventOptions({
            isSemu,
            hasTransactions,
            error,
            defaultAnalytics,
            replacementReason: currentReason === null || currentReason === void 0 ? void 0 : currentReason.value
        })[activeStep];
        if (!isSuccess || !eventOptions || hasErrorOccured) {
            return;
        }
        if (error) {
            setHasErrorOccured(true);
        }
        if (triggerAnalyticsEvent) {
            if (!fired) {
                setFired(true);
                triggerAnalyticsEvent(eventOptions);
            }
        }
        else {
            // eslint-disable-next-line no-console
            console.warn('triggerAnalyticsEvent is not defined. Please provide a valid function.');
        }
    }, [
        defaultAnalytics,
        activeStep,
        isSuccess,
        isSemu,
        hasTransactions,
        error,
        hasErrorOccured,
        currentReason,
        triggerAnalyticsEvent,
        fired
    ]);
};
export default useAnalytics;
//# sourceMappingURL=useAnalytics.js.map